// Generated by CoffeeScript 2.7.0
var COLORS, ICONS, IconColorPicker, color_picker, icon_picker;

import ItemPicker from 'trunks/vue/admin/components/libs/item_picker.js';

ICONS = _cargo.message_group.icons;

COLORS = _cargo.tag.colors;

icon_picker = Vue.extend({
  components: {
    'item-picker': ItemPicker
  },
  props: {
    pickedIcon: {
      type: String,
      default: _.sample(ICONS)
    },
    icons: {
      type: Array,
      default: function() {
        return ICONS;
      }
    },
    groupLength: {
      type: Number,
      default: 9
    }
  },
  data: function() {
    return {
      value: this.pickedIcon
    };
  },
  template: `<item-picker :items='icons'
             :groupLength='groupLength'
             wrapperClass='icon-picker'
             @valueChanged='updateValueFunc'>
  <template slot='item-template' slot-scope='{ item }'>
    <slot name='item-template' :item='item'>
      <i :class='iconItemClass(item)'></i>
    </slot>
  </template>
</item-picker>`,
  methods: {
    iconItemClass: function(icon) {
      if (icon === this.value) {
        return icon;
      } else {
        return [icon, 'active'];
      }
    },
    updateValueFunc: function(icon) {
      this.value = icon;
      return this.$emit('valueChanged', this.value);
    }
  }
});

color_picker = Vue.extend({
  components: {
    'item-picker': ItemPicker
  },
  props: {
    pickedColor: {
      type: String,
      default: _.sample(COLORS)
    },
    colors: {
      type: Array,
      default: function() {
        return COLORS;
      }
    }
  },
  data: function() {
    return {
      value: this.pickedColor
    };
  },
  template: `<item-picker :items='colors'
            :groupLength='8'
            wrapperClass='color-picker'
            @valueChanged='updateValueFunc'>
  <template slot='item-template' slot-scope='{ item }'>
    <slot name='item-template' :item='item'>
      <i :class='colorItemClass(item)'
        :style='{ color: item }'>
      </i>
    </slot>
  </template>
</item-picker>`,
  methods: {
    colorItemClass: function(color) {
      if (color === this.value) {
        return 'slp-check-circle';
      } else {
        return 'slp-circle';
      }
    },
    updateValueFunc: function(icon) {
      this.value = icon;
      return this.$emit('valueChanged', this.value);
    }
  }
});

export default IconColorPicker = Vue.extend({
  components: {
    'color-picker': color_picker,
    'icon-picker': icon_picker
  },
  props: {
    pickedIcon: String,
    pickedColor: String,
    iconGroupLength: Number,
    pickerMode: {
      type: String,
      default: 'all' //'icon', 'color', 'all'
    }
  },
  data: function() {
    return {
      icon: this.pickedIcon,
      color: this.pickedColor
    };
  },
  template: `<div class="icon-color-picker">
  <color-picker :pickedColor='color' @valueChanged='colorChanged' v-if="pickerMode != 'icon'"></color-picker>
  <icon-picker :pickedIcon='icon' :groupLength='iconGroupLength' @valueChanged='iconChanged' v-if="pickerMode != 'color'">
    <template slot='item-template' slot-scope='{ item }' v-if="pickerMode == 'all'">
      <div class="icon-wrapper" :class="{ 'selected': icon == item }">
        <i :class='item' :style='{ color: color }'></i>
        <div class="custom-wrapper"
            :style='{ borderColor: color }'>
          <div class="background"
              :style='{ backgroundColor: color }'></div>
        </div>
      </div>
    </template>
  </icon-picker>
</div>`,
  methods: {
    colorChanged: function(color) {
      this.color = color;
      return this.$emit('colorChanged', this.color);
    },
    iconChanged: function(icon) {
      this.icon = icon;
      return this.$emit('iconChanged', this.icon);
    },
    getData: function() {
      return {
        icon: this.icon,
        bgcolor: this.color
      };
    }
  }
});
